export default function TitleBox({ title, text }: { title: string; text: string | React.ReactNode }) {
    return (
        <div className="relative border border-[rgba(221,221,221,0.6)] bg-[rgba(255,255,255,0.8)] text-center">
            <span
                className="pointer-events-none absolute left-[-1px] top-[-1px] h-[13px] w-[13px]
                before:absolute before:left-[1px] before:top-0 before:h-[1px] before:w-[11px] before:bg-primary before:content-['']
                after:absolute after:left-0 after:top-[1px] after:h-[11px] after:w-[1px] after:bg-primary after:content-['']"
            />
            <span
                className="pointer-events-none absolute bottom-[-1px] left-[-1px] h-[13px] w-[13px]
                before:absolute before:bottom-0 before:left-[1px] before:h-[1px] before:w-[11px] before:bg-primary before:content-['']
                after:absolute after:bottom-[1px] after:left-0 after:h-[11px] after:w-[1px] after:bg-primary after:content-['']"
            />
            <h4 className="relative py-[20px] md:py-[40px]">
                <span
                    className="pointer-events-none absolute right-[-1px] top-[-1px] h-[13px] w-[13px]
                    before:absolute before:right-[1px] before:top-0 before:h-[1px] before:w-[11px] before:bg-primary before:content-['']
                    after:absolute after:right-0 after:top-[1px] after:h-[11px] after:w-[1px] after:bg-primary after:content-['']"
                />
                <span
                    className="pointer-events-none absolute bottom-[-1px] right-[-1px] h-[13px] w-[13px]
                    before:absolute before:bottom-0 before:right-[1px] before:h-[1px] before:w-[11px] before:bg-primary before:content-['']
                    after:absolute after:bottom-[1px] after:right-0 after:h-[11px] after:w-[1px] after:bg-primary after:content-['']"
                />
                <em className="block pb-[12px] font-['GongGothicLight'] text-[16px] not-italic text-primary md:pb-5 md:text-[24px]">
                    {title}
                </em>
                <div className="block font-['GongGothicBold'] text-[32px] leading-none text-black md:text-[60px]">
                    {text}
                </div>
            </h4>
        </div>
    );
}
